import React from "react";
import { Button, styled, Typography } from "@mui/material";

const DeleteConfirmationModal = (props) => {
    const { deleteRule, toggleModal, parentEntityTypeKey, modal } = props;

    const { ruleKey } = modal.data;

    return (
        <React.Fragment>
            <Paper>
                <ModalHeader variant="h6">
                    Delete Rule?
                </ModalHeader>
                <span style={{ marginBottom: "20px" }}>Are you sure you want to delete this rule?</span>
                <span>
                    <Button variant="outlined" onClick={() => toggleModal(false)} color="primary">
                        Cancel
                    </Button>
                    <DeleteButton
                        variant="contained"
                        onClick={() => deleteRule(ruleKey, parentEntityTypeKey)}
                    >
                        Delete
                    </DeleteButton>
                </span>
            </Paper>
        </React.Fragment>
    );
};

const Paper = styled('div')({
    display: "flex",
    flexDirection: "column",
    background: "white",
    top: "50%",
    left: "50%",
    width: "300px",
    height: "125px",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    borderRadius: "3px",
    boxShadow: " 0 3px 7px rgba(0, 0, 0, 0.3)",
    padding: "20px",
    alignItems: "center",
});

const ModalHeader = styled(Typography)({
    fontWeight: "600",
    marginBottom: "20px",
});

const DeleteButton = styled(Button)({
    color: "#fff",
    backgroundColor: "#d32f2f",
    "&:hover": {
        backgroundColor: "#c62828",
    },
});

export default DeleteConfirmationModal;
